import { stats } from "@/mocks/blog";

export default function Hero() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section id="top" className="relative overflow-hidden bg-background-50">
      {/* decorative blobs */}
      <div className="pointer-events-none absolute -right-24 -top-24 h-80 w-80 rounded-full bg-primary-100/60 blur-3xl"></div>
      <div className="pointer-events-none absolute -left-24 top-40 h-72 w-72 rounded-full bg-accent-100/70 blur-3xl"></div>
      <div className="pointer-events-none absolute bottom-0 right-1/3 h-64 w-64 rounded-full bg-secondary-100/70 blur-3xl"></div>

      <div className="relative mx-auto flex min-h-[92vh] w-full max-w-7xl flex-col justify-center px-4 pb-16 pt-28 md:px-6">
        <div className="grid items-center gap-10 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1.5 text-xs font-semibold text-primary-700">
              <i className="ri-focus-3-fill" aria-hidden="true"></i>
              <span>一个爱说实话的普通人的碎碎念</span>
            </div>

            <h1 className="font-display text-4xl font-black leading-tight text-foreground-950 md:text-6xl">
              吾爱吃瓜，
              <br />
              <span className="text-primary-600">只吃自己看得懂的瓜</span>
            </h1>

            <p className="mt-6 max-w-xl text-base leading-relaxed text-foreground-700 md:text-lg">
              在这里，没有冷冰冰的通稿，只有<strong className="font-semibold text-foreground-900">我的看法</strong>与
              <strong className="font-semibold text-foreground-900">主观评价</strong>。我以个人视角聊热点、职场、科技与生活，
              把<strong className="font-semibold text-foreground-900">吃瓜心得</strong>和
              <strong className="font-semibold text-foreground-900">碎碎念</strong>统统写下来，陪你看懂事件背后的情绪与人。
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <button
                onClick={() => scrollTo("articles")}
                className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                读读我的观点
              </button>
              <button
                onClick={() => scrollTo("rambling")}
                className="whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
              >
                <i className="ri-chat-3-line mr-1" aria-hidden="true"></i>
                看看碎碎念
              </button>
            </div>

            <dl className="mt-12 grid grid-cols-2 gap-x-6 gap-y-6 sm:grid-cols-4">
              {stats.map((s) => (
                <div key={s.label}>
                  <dd className="font-display text-2xl font-bold text-foreground-950 md:text-3xl">{s.value}</dd>
                  <dt className="mt-1 text-xs text-foreground-500 md:text-sm">{s.label}</dt>
                </div>
              ))}
            </dl>
          </div>

          {/* editorial card stack */}
          <div className="hidden lg:col-span-5 lg:block">
            <div className="relative ml-auto w-full max-w-md">
              <div className="relative overflow-hidden rounded-lg border border-background-200 bg-background-100">
                <div className="flex items-center gap-2 border-b border-background-200 bg-background-100 px-4 py-3">
                  <span className="h-2.5 w-2.5 rounded-full bg-primary-400"></span>
                  <span className="h-2.5 w-2.5 rounded-full bg-secondary-400"></span>
                  <span className="h-2.5 w-2.5 rounded-full bg-accent-400"></span>
                  <span className="ml-2 text-xs font-medium text-foreground-500">吾爱吃瓜 · 今日随笔</span>
                </div>
                <div className="p-5">
                  <p className="font-display text-lg font-bold leading-snug text-foreground-950">
                    同一件事刷屏七遍，我该如何保持清醒？
                  </p>
                  <p className="mt-2 text-xs leading-relaxed text-foreground-600">
                    在信息过载的时代，我们缺的不是瓜，而是判断力。这是我的「三问筛选法」。
                  </p>
                  <div className="mt-4 flex items-center gap-2 text-xs text-foreground-500">
                    <span className="rounded-full bg-primary-100 px-2 py-0.5 font-semibold text-primary-700">社会热点</span>
                    <span>6 分钟读完</span>
                  </div>
                  <button
                    onClick={() => scrollTo("articles")}
                    className="mt-4 inline-flex cursor-pointer items-center gap-1 text-sm font-semibold text-primary-600 hover:text-primary-700"
                  >
                    继续阅读 <i className="ri-arrow-right-line" aria-hidden="true"></i>
                  </button>
                </div>
              </div>

              <div className="absolute -bottom-8 -left-6 w-52 rotate-[-4deg] rounded-lg border border-background-200 bg-background-100 p-4 shadow-sm">
                <div className="flex items-center gap-2">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                    <i className="ri-quote-text" aria-hidden="true"></i>
                  </span>
                  <span className="text-xs font-bold text-foreground-800">今日一句</span>
                </div>
                <p className="mt-2 text-xs leading-relaxed text-foreground-600">
                  "吃瓜是乐趣，但别让它填满你全部的生活。"
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}